export const BANKSLIP_PAYMENT_EN_US = {
	// Barcode input step
	infoTitle: "Information",
	barcodeInfo:
		"Up to 12 deposit slips (payment) will be accepted with a minimum value of R$ 10.00 that will be deducted from the available balance.",
	barcodeLabel: "Barcode",
	barcodePlaceholder: "Enter or paste the slip code here",
	invalidBarcode: "Invalid barcode. Please check and try again.",
	pasteCode: "Paste code",
	stepBarcode: "Barcode",
	stepValue: "Slip value",
	stepReview: "Review",

	// Payment amount section (Step 1)
	paymentAmountQuestion: "How much do you want to pay?",
	suggestedAmountMessage: "The suggested amount for this slip is {{amount}}",
	paymentAmountLabel: "Payment amount",

	// Review step tabs
	tabValues: "Slip value",
	tabInfo: "Data review",

	// Review step - Values
	valuesReview: "Values Review",
	bankSlipValue: "Slip value",
	anticipationFee: "Fine and interest",
	discounts: "Discounts",
	totalToPay: "Total to pay",

	// Review step - Info
	bankSlipInfo: "Slip Information",
	beneficiary: "Beneficiary",
	recipientTaxId: "Beneficiary tax ID",
	barCode: "Code number",
	dueDate: "Due date",
	bank: "Bank",

	// Alerts
	inactiveBankslipTitle: "Inactive slip",
	inactiveBankslipMessage:
		"This slip has already been paid or there was an issue with its issuance. Please check the code and try again.",
	expiredBankslipMessage:
		"This slip has expired and can no longer be paid. Please check the code and try again.",
	missingRecipientTitle: "Recipient data unavailable",
	missingRecipientMessage:
		"We couldn't identify the beneficiary data (name and tax ID). Please check the slip and try again.",
	insufficientBalance: "Insufficient balance",
	insufficientBalanceDescription: "Insufficient available balance to make the payment.",
	scheduledWarningTitle: "Payment will be scheduled for the next business day",
	scheduledWarningMessage:
		"As this request is being made after 3 PM, the slip will be paid on the next business day, already with the updated amount.",

	// Status modal - Success
	successTitle: "All set!",
	successDescription: "The slip will be sent for processing by the Financial department.",
	conclude: "Finish",
	close: "Close",

	// Status modal - Error
	errorTitle: "Unable to complete the request",
	errorDescription: "There was a problem while trying to complete the request.",
	goBack: "Go back",
	tryAgain: "Try again",

	// Actions
	continue: "Next",
	confirmRequest: "Confirm request",

	// Loading
	processingPayment: "Processing payment...",

	// Amount validation
	amountBelowMinimum: "The entered amount is less than the minimum allowed.",

	// Generic error
	genericError: "An error occurred. Please try again.",
};
